{
  "INBOX": {
    "LIST": {
      "404": "V této skupině nejsou žádná aktivní oznámení.",
      "TITLE": "Schránka",
      "DISPLAY_DROPDOWN": "Zobrazit",
      "LOADING": "Načítání oznámení",
      "NO_NOTIFICATIONS": "Žádná oznámení",
      "NOTE": "Oznámení ze všech přihlášených schránek",
      "NO_MESSAGES_AVAILABLE": "Jejda! Nelze načíst zprávy",
      "SNOOZED_UNTIL": "Odloženo do",
      "SNOOZED_UNTIL_TOMORROW": "Odloženo do zítřka",
      "SNOOZED_UNTIL_NEXT_WEEK": "Odloženo do příštího týdne"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Odložit oznámení",
      "DELETE": "Smazat oznámení",
      "BACK": "Zpět"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "Byli jste zmíněni v konverzaci",
      "CONVERSATION_CREATION": "Vytvořena nová konverzace",
      "CONVERSATION_ASSIGNMENT": "Konverzace vám byla přiřazena",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nová zpráva v mě přiřazené konverzaci",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nová zpráva v konverzaci, které se účastníte",
      "SLA_MISSED_FIRST_RESPONSE": "Cíl SLA první odpovědi byl pro konverzaci zmeškaný",
      "SLA_MISSED_NEXT_RESPONSE": "Cíl SLA další odpovědi byl pro konverzaci zmeškaný",
      "SLA_MISSED_RESOLUTION": "Cíl SLA vyřešení byl pro konverzaci zmeškaný"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Zmíněno",
      "CONVERSATION_ASSIGNMENT": "Přiděleno vám",
      "CONVERSATION_CREATION": "Nová konverzace",
      "SLA_MISSED_FIRST_RESPONSE": "Porušení SLA",
      "SLA_MISSED_NEXT_RESPONSE": "Porušení SLA",
      "SLA_MISSED_RESOLUTION": "Porušení SLA",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nová zpráva",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nová zpráva",
      "SNOOZED_UNTIL": "Odloženo do {time}",
      "SNOOZED_ENDS": "Odložení skončilo",
      "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Nová zpráva"
    },
    "NO_CONTENT": "Žádný obsah k dispozici",
    "PHONE_CALL_TYPES": {
      "OUTBOUND_CONNECTED": "Odchozí hovor - Spojený",
      "OUTBOUND_FAILED": "Odchozí hovor - Neúspěšný",
      "INBOUND_MISSED": "Příchozí hovor - Zmeškaný",
      "INBOUND_UNANSWERED_MISSED": "Příchozí hovor - Zmeškaný nevyřízený",
      "INBOUND_AGENT": "Příchozí hovor - Obsloužený agentem",
      "INBOUND_IVR": "Příchozí hovor - Obsloužený IVR",
      "DEFAULT": "Telefonní hovor"
    },
    "MENU_ITEM": {
      "MARK_AS_READ": "Označit jako přečtené",
      "MARK_AS_UNREAD": "Označit jako nepřečtené",
      "SNOOZE": "Odložit",
      "DELETE": "Smazat",
      "MARK_ALL_READ": "Označit vše jako přečtené",
      "DELETE_ALL": "Smazat vše",
      "DELETE_ALL_READ": "Smazat včechny přečtené"
    },
    "DISPLAY_MENU": {
      "SORT": "Řadit",
      "DISPLAY": "Zobrazit:",
      "SORT_OPTIONS": {
        "NEWEST": "Nejnovější",
        "OLDEST": "Nejstarší",
        "PRIORITY": "Priorita"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Odložené",
        "READ": "Přečtené",
        "LABELS": "Štítky",
        "CONVERSATION_ID": "ID konverzace"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Oznámení označeno jako přečtené",
      "MARK_AS_UNREAD": "Oznámení označeno jako nepřečtené",
      "SNOOZE": "Oznámení odloženo",
      "DELETE": "Oznámení smazáno",
      "MARK_ALL_READ": "Všechna oznámení označena jako přečtená",
      "DELETE_ALL": "Všechna oznámení smazána",
      "DELETE_ALL_READ": "Všechna přečtená oznámení smazána"
    }
  }
}
